// Entry point. In dev, drop any registered service worker before app modules load — an active SW
// caches /src/* cache-first, so a stale bundle from a previous production visit would
// otherwise win over Vite's fresh sources (symptom: code changes never appear on localhost).
async function start(): Promise<void> {
  if (import.meta.env.DEV) {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k)))
    }
  }
  await import('./app')
}

void start()
